import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator as CalcIcon, Mail, Twitter, Github, Linkedin } from 'lucide-react';
import { CATEGORIES } from '../data/mock';

const SOCIAL_LINKS = [
  { name: 'twitter', Icon: Twitter, href: '#' },
  { name: 'github', Icon: Github, href: '#' },
  { name: 'linkedin', Icon: Linkedin, href: '#' },
  { name: 'mail', Icon: Mail, href: '#' },
];

const Footer = () => {
  return (
    <footer className="bg-bharat-navy text-slate-300 mt-16">
      <div className="tricolor-bar" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-saffron-500 to-indgreen-500 flex items-center justify-center">
                <CalcIcon className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-display font-bold text-lg text-white">
                bharat<span className="text-saffron-400">-</span>calculator
              </span>
            </Link>
            <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
              Free, fast and accurate online calculators made for Bharat. From EMI to BMI — all your everyday calculations in one place.
            </p>
            <div className="flex gap-3 mt-4">
              {SOCIAL_LINKS.map(({ name, Icon, href }) => (
                <a key={name} href={href} aria-label={name} className="w-9 h-9 rounded-full bg-slate-800 hover:bg-saffron-500 flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {CATEGORIES.map(cat => (
            <div key={cat.name}>
              <h4 className="font-display font-semibold text-white text-sm mb-3">{cat.name.replace(' Calculators', '')}</h4>
              <ul className="space-y-2">
                {cat.items.slice(0, 5).map(item => (
                  <li key={item.id}>
                    {item.disabled ? (
                      <span className="text-xs text-slate-500">{item.name}</span>
                    ) : (
                      <Link to={`/calculator/${item.id}`} className="text-xs text-slate-400 hover:text-saffron-400 transition-colors">
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-slate-800 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} bharat-calculator.com — Built with <span className="text-saffron-400">♥</span> in India
          </p>
          <div className="flex gap-5 text-xs text-slate-500">
            <Link to="/privacy" className="hover:text-slate-300">Privacy</Link>
            <Link to="/about" className="hover:text-slate-300">About</Link>
            <Link to="/contact" className="hover:text-slate-300">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
